import { CbSearchInputModule } from '@chubb/ui-components/cb-search-input';
import { CbSpinnerModule } from '@chubb/ui-components/cb-spinner';
import { CbInputModule } from '@chubb/ui-components/cb-input';
import { CbSelectChoiceModule } from '@chubb/ui-components/cb-select-choice';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxMaskDirective } from 'ngx-mask';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppAnalyticsModule } from '../../../directives/app-analytics.module';
import { QuoteStepComponent } from './quote-step.component';
import { CSBCoreModule } from '../../../csb-core/csb-core.module';
import { CsbBusinessTypeComponent } from './csb-business-type/csb-business-type.component';
import { CsbRevenueComponent } from './csb-revenue/csb-revenue.component';
import { CsbZipcodeComponent } from './csb-zipcode/csb-zipcode.component';
import { EmailModule } from '../email/email.module';
import { CsbYesNoModule } from '../../../csb-quote/csb-yes-no/csb-yes-no.module';
import { CsbWebsiteModule } from '../../../csb-quote/csb-website/csb-website.module';
import { CsbQuestionModule } from '../../../csb-quote/csb-question/csb-question.module';
import { CsbLeftPanelComponent } from './csb-left-panel/csb-left-panel.component';
import { ReferralMessageModule } from '../referral-message/referral-message.module';
import { CsbCoreZipcodeModule } from '../../../csb-quote/csb-zipcode/csb-core-zipcode.module';
import { SelectModule } from 'primeng/select';
@NgModule({
    declarations: [
        QuoteStepComponent,
        CsbBusinessTypeComponent,
        CsbRevenueComponent,
        CsbZipcodeComponent,
        CsbLeftPanelComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppAnalyticsModule,
        CbSearchInputModule,
        AutoCompleteModule,
        MatButtonToggleModule,
        CSBCoreModule,
        CsbYesNoModule,
        EmailModule,
        CsbQuestionModule,
        ReferralMessageModule,
        EmailModule,
        CbSpinnerModule,
        CbInputModule,
        ProgressSpinnerModule,
        CsbCoreZipcodeModule,
        CbSelectChoiceModule,
        SelectModule,
        CsbWebsiteModule,
        NgxMaskDirective,
    ],
    exports: [QuoteStepComponent],
})
export class QuoteStepModule {}
